import { defineComponent as n } from "vue";
import { SequiterButton as o, BUTTON_VARIANTS as s } from "@ado/acs-standard-library";
const p = n({
  name: "BasePrompt",
  components: {
    SequiterButton: o
  },
  props: {
    yesAction: {
      type: Function,
      required: !0
    },
    noAction: {
      type: Function,
      required: !0
    }
  },
  setup(e) {
    return {
      buttonVariants: s,
      yesClicked: (t) => {
        e.yesAction(t);
      },
      noClicked: (t) => {
        e.noAction(t);
      },
      baseClassName: "base-prompt"
    };
  }
});
export {
  p as default
};
//# sourceMappingURL=index4.js.map
